import { render } from "./sanati.vue?vue&type=template&id=36d405e5"
import script from "./sanati.vue?vue&type=script&lang=js"
export * from "./sanati.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/touran-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__